import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Linkedin from "@iconscout/react-unicons/icons/uil-linkedin";
import Gitub from "@iconscout/react-unicons/icons/uil-github";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <span>francedermaz@gmail.com</span>
        <div className="f-icons">
          <a target="_blank" href="https://www.linkedin.com/in/francedermaz">
          <Linkedin color="white" size={"3rem"} />
          </a>
          <a target="_blank" href="https://github.com/francedermaz/">
          <Gitub color="white" size={"3rem"} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
